import { AsyncJob, NewJob } from 'types/responses/AsyncJob';
import { create } from 'zustand';

type StoredJobs = {
  jobs: NewJob[];
  append: (job: NewJob) => void;
  remove: (jobId: NewJob['_id']) => void;
  updateStatus: (jobId: NewJob['_id'], newStatus: AsyncJob['status']) => void;
};

const usePendingJobStore = create<StoredJobs>((setState, getState, store) => ({
  jobs: [],
  append: (job) => {
    setState(({ jobs }) => ({ jobs: [...jobs, job] }));
  },
  remove: (jobId) => {
    setState(({ jobs }) => ({ jobs: jobs.filter((j) => j._id !== jobId) }));
  },
  updateStatus: (jobId, newStatus) => {
    setState(({ jobs }) => ({
      jobs: jobs.map((j) => {
        if (j._id === jobId) {
          return {
            ...j,
            status: newStatus,
          };
        } else {
          return j;
        }
      }),
    }));
  },
}));

export default usePendingJobStore;
